import apiClient from './apiClient';

export function registerUser(registerRequest) {
  return apiClient.post('/user', registerRequest);
}

export const loginUser = async loginRequest => {
  return apiClient.post('/user/auth', loginRequest);
};

export const logoutUser = async () => {
  const { data } = await apiClient.post('/user/logout');
  return data;
};

export const getUserDataQuery = async () => {
  const { data } = await apiClient.get('/user');
  return data;
};

export const renameUser = async username => {
  const { data } = await apiClient.put('/user', { username });
  return data;
};

export const deleteUser = async () => {
  const { data } = await apiClient.delete('/user');
  return data;
};

export const createTeam = async teamObject => {
  const { data } = await apiClient.post('/user/team', teamObject);
  return data;
};

export const updateTeam = async teamObject => {
  const { data } = await apiClient.put('/user/team', teamObject);
  return data;
};

export const deleteTeam = async () => {
  const { data } = await apiClient.delete('/user/team');
  return data;
};

export const joinClassroom = async joinClassroomRequest => {
  const { data } = await apiClient.post(
    '/user/classroom',
    joinClassroomRequest
  );
  return data;
};

export const leaveClassroom = async () => {
  const { data } = await apiClient.delete('/user/classroom');
  return data;
};

export const getOtherUser = async username => {
  const { data } = await apiClient.get(`/user/${username}`);
  return data;
};
